"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var ui_virtualized_1 = require("@vidazoo/ui-virtualized");
var classnames_1 = require("classnames");
var common_1 = require("../../common");
var DataGridRow = /** @class */ (function (_super) {
    tslib_1.__extends(DataGridRow, _super);
    function DataGridRow(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.setMouseOnRow = function () {
            _this.setState({ mouseOnRow: true });
        };
        _this.removeMouseOnRow = function () {
            _this.setState({ mouseOnRow: false });
        };
        _this.state = { mouseOnRow: false };
        return _this;
    }
    DataGridRow.prototype.render = function () {
        var _this = this;
        var _a;
        var _b = this.props, children = _b.children, className = _b.className, theme = _b.theme, columnsWidth = _b.columnsWidth, edge = _b.edge, highlight = _b.highlight, truncate = _b.truncate, slim = _b.slim, breakWord = _b.breakWord, index = _b.index, density = _b.density, freezeColumnIndex = _b.freezeColumnIndex;
        var classes = classnames_1.default(theme.row, className, (_a = {},
            _a[theme.edge] = edge,
            _a[theme.highlight] = highlight,
            _a[theme.truncate] = truncate,
            _a[theme.breakWord] = breakWord,
            _a[theme.even] = index % 2 === 0,
            _a[theme.slim] = slim,
            _a));
        var idx = -1;
        return (React.createElement(ui_virtualized_1.Row, { className: classes, onMouseOver: this.setMouseOnRow, onMouseLeave: this.removeMouseOnRow, index: index }, React.Children.map(children, (function (child) {
            if (!child) {
                return null;
            }
            idx++;
            return React.cloneElement(child, tslib_1.__assign({ width: columnsWidth[idx], mouseOnRow: _this.state.mouseOnRow, isFreeze: (freezeColumnIndex >= idx), index: idx, key: idx, density: density }, child.props));
        }))));
    };
    DataGridRow.defaultProps = {
        density: common_1.Density.Small
    };
    return DataGridRow;
}(React.Component));
exports.default = DataGridRow;
